import axiosInstance from "../api.axiosInstance"
import type {
  ContractPackageStatusDto,
  SupplementalAttemptDto,
} from "../dto/contract-package.dto"

class ContractPackageService {
  async getPackageStatus(proposalId: string): Promise<ContractPackageStatusDto> {
    const response = await axiosInstance.get<ContractPackageStatusDto>(
      `/contracting/v2/proposals/${proposalId}/contract-package`,
    )
    return response.data
  }

  async retrySupplementalSend(
    attemptId: string,
  ): Promise<SupplementalAttemptDto> {
    const response = await axiosInstance.post<SupplementalAttemptDto>(
      `/contracting/v2/supplemental-attempts/${attemptId}/retry`,
    )
    return response.data
  }
}

export const contractPackageService = new ContractPackageService()
